/* User Info API constants */
export const FETCH_USER_INFO = 'FETCH_USER_INFO';
export const FETCH_USER_INFO_SUCCESS = 'FETCH_USER_INFO_SUCCESS';
export const FETCH_USER_INFO_ERROR = 'FETCH_USER_INFO_ERROR';

export const FETCH_MULTIPLE_PROFILES='FETCH_MULTIPLE_PROFILES';
export const FETCH_MULTIPLE_PROFILES_SUCCESS='FETCH_MULTIPLE_PROFILES_SUCCESS';

// /** Note summary */
export const FETCH_NOTE_SUMMARY_REQUEST = 'FETCH_NOTE_SUMMARY_REQUEST';
export const FETCH_NOTE_SUMMARY_REQUEST_SUCCESS = 'FETCH_NOTE_SUMMARY_REQUEST_SUCCESS';
export const FETCH_NOTE_SUMMARY_REQUEST_ERROR = 'FETCH_NOTE_SUMMARY_REQUEST_ERROR'

/* Activity notification  */
export const FETCH_ACTIVITY_NOTIFICATION_REQUEST = 'FETCH_ACTIVITY_NOTIFICATION_REQUEST';
export const FETCH_ACTIVITY_NOTIFICATION_REQUEST_SUCCESS = 'FETCH_ACTIVITY_NOTIFICATION_REQUEST_SUCCESS';
export const FETCH_ACTIVITY_NOTIFICATION_REQUEST_ERROR = 'FETCH_ACTIVITY_NOTIFICATION_REQUEST_ERROR';


export const RESET_CHANGE_ACTIVITY_ASSIGNEE_STATE = 'RESET_CHANGE_ACTIVITY_ASSIGNEE_STATE';